import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { SkinInterface, setEditId, setEditError, selectSkinById } from "../../../store/roblox/skinsSlice";
import { updateSkin, fetchSkin } from "../../../actions/roblox/skinsActions";
import { objToFormData } from "../../../helpers/FormHelper";

import DrawerRight from "../../../componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "../../../componets/AlertBlock";

const Edit = () => {
  const dispatch    = useAppDispatch();
  const location    = useLocation();
  const id: any     = useAppSelector(state => state.roblox.skins.editId);
  const error       = useAppSelector(state => state.roblox.skins.editError);
  const skin = useAppSelector(state => id ? selectSkinById(state, id) : undefined);

  useEffect(() => {
    if (id) {
      dispatch(fetchSkin(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    dispatch(setEditId(null));
  }, [location, dispatch]);

  function onCloseError() {
    dispatch(setEditError(null));
  }

  function onClose() {
    dispatch(setEditId(null));
  }

  function onFinish(data: SkinInterface) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(data: SkinInterface) {
    const formData: any = objToFormData(data);
    const resultAction = await dispatch(updateSkin({ id, data: formData }));

    if (updateSkin.fulfilled.match(resultAction)) {
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-skin'>
        <h6 className="v-content-label">Edit Skin</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form params={skin} onFinish={onFinish} />
      </div>
    </DrawerRight>
  )
}

export default Edit;
